export var MISSIONS_GAMEPLAY_STATE_NOT_FOUND_ERROR = 'MISSIONS_GAMEPLAY_STATE_NOT_FOUND';